<div class="content-container automation-page">
  <nav class="navbar sticky-top automation-page__nav">
    <div class="d-grid gap-2 d-flex navbar-brand">
      <button (click)="location.back()" type="button" class="btn btn-primary" aria-label="Back"
        ngbTooltip="Back" placement="bottom">
        <fa-icon [icon]="faAngleLeft"></fa-icon>
      </button>

      <h2 class="mobileHeading mb-0">Automation</h2>
    </div>
  </nav>

  <div class="automation-page__stepper-wrap">
    <div class="automation-page__stepper">
      <div class="stepper-item stepper-item--clickable" [class.stepper-item--active]="currentStep() === 1"
        [class.stepper-item--done]="currentStep() > 1" (click)="goToStep(1)">
        <div class="stepper-item__circle">
          <span *ngIf="currentStep() <= 1">1</span>
          <span *ngIf="currentStep() > 1">✓</span>
        </div>
        <div class="stepper-item__content">
          <div class="stepper-item__label">Step 1</div>
          <div class="stepper-item__title">Single</div>
        </div>
      </div>

      <div class="stepper-line"></div>

      <div class="stepper-item stepper-item--clickable" [class.stepper-item--active]="currentStep() === 2"
        [class.stepper-item--done]="currentStep() > 2" (click)="goToStep(2)">
        <div class="stepper-item__circle">
          <span *ngIf="currentStep() <= 2">2</span>
          <span *ngIf="currentStep() > 2">✓</span>
        </div>
        <div class="stepper-item__content">
          <div class="stepper-item__label">Step 2</div>
          <div class="stepper-item__title">Multi-Year</div>
        </div>
      </div>

      <div class="stepper-line"></div>

      <div class="stepper-item stepper-item--clickable" [class.stepper-item--active]="currentStep() === 3"
        [class.stepper-item--done]="currentStep() > 3" (click)="goToStep(3)">
        <div class="stepper-item__circle">
          <span *ngIf="currentStep() <= 3">3</span>
          <span *ngIf="currentStep() > 3">✓</span>
        </div>
        <div class="stepper-item__content">
          <div class="stepper-item__label">Step 3</div>
          <div class="stepper-item__title">Expiring</div>
        </div>
      </div>

      <div class="stepper-line"></div>

      <div class="stepper-item stepper-item--clickable" [class.stepper-item--active]="currentStep() === 4"
        [class.stepper-item--done]="currentStep() > 4" (click)="goToStep(4)">
        <div class="stepper-item__circle">4</div>
        <div class="stepper-item__content">
          <div class="stepper-item__label">Step 4</div>
          <div class="stepper-item__title">Summary</div>
        </div>
      </div>
    </div>
  </div>

  <div class="automation-page__body">
    <div class="automation-page__body-inner">
      <ng-container [ngSwitch]="currentStep()">
        <div *ngSwitchCase="1" class="automation-page__panel">
          <div class="automation-page__section-header">
            <h3 class="automation-page__section-title">Step 1: Select Single Projects</h3>
            <p class="automation-page__section-subtitle">
              Select the single year projects you want to include in this cloning job.
            </p>
          </div>

          <div class="automation-page__content-slot">
            <app-batch-cloning-table *ngIf="!isLoading()" class="automation-page__table" [rows]="rowsForCurrentStep()"
              [isWizardMode]="true" [preselectedProjectIds]="selectedIdsForCurrentStep()"
              [projectType]="'single'"
              (selectionChange)="onStepClone($event)"
              (yearChange)="loadBatchCloningJobsByYear($event)"
              (validationChange)="onStepValidation($event)"></app-batch-cloning-table>
          </div>
        </div>

        <div *ngSwitchCase="2" class="automation-page__panel">
          <div class="automation-page__section-header">
            <h3 class="automation-page__section-title">Step 2: Select Multi-Year Projects</h3>
            <p class="automation-page__section-subtitle">
              Select the MYA projects you want to include in this cloning job.
            </p>
          </div>

          <div class="automation-page__content-slot">
            <app-batch-cloning-table *ngIf="!isLoading()" class="automation-page__table" [rows]="rowsForCurrentStep()"
              [isWizardMode]="true" [preselectedProjectIds]="selectedIdsForCurrentStep()"
              [projectType]="'mya'"
              (selectionChange)="onStepClone($event)"
              (yearChange)="loadBatchCloningJobsByYear($event)"
              (validationChange)="onStepValidation($event)"></app-batch-cloning-table>
          </div>
        </div>

        <div *ngSwitchCase="3" class="automation-page__panel">
          <div class="automation-page__section-header">
            <h3 class="automation-page__section-title">Step 3: Select Expiring MYA Projects</h3>
            <p class="automation-page__section-subtitle">
              Select expiring MYA projects you want to renew in this cloning job.
            </p>
          </div>

          <div class="automation-page__content-slot"
            [class.automation-page__content-slot--empty]="!isLoading() && expiringRows().length === 0">
            <ng-container *ngIf="!isLoading()">
              <div *ngIf="expiringRows().length === 0" class="automation-page__empty-state" role="status">
                <fa-icon [icon]="faInbox" class="automation-page__empty-icon" aria-hidden="true"></fa-icon>
                <p class="automation-page__empty-title">No expiring MYA projects</p>
                <p class="automation-page__empty-text">
                  Nothing is available to renew here yet. Use <strong>Next</strong> to continue, your other selections
                  are unchanged.
                </p>
              </div>
              <app-batch-cloning-table *ngIf="expiringRows().length > 0" class="automation-page__table"
                [rows]="rowsForCurrentStep()" [isWizardMode]="true"
                [projectType]="'expiring'"
                (yearChange)="loadBatchCloningJobsByYear($event)"
                [preselectedProjectIds]="selectedIdsForCurrentStep()" (selectionChange)="onStepClone($event)"
                (validationChange)="onStepValidation($event)"></app-batch-cloning-table>
            </ng-container>
          </div>
        </div>

        <div *ngSwitchCase="4" class="automation-page__panel">
          <div class="automation-page__section-header">
            <h3 class="automation-page__section-title">Step 4: Review & Confirm</h3>
            <p class="automation-page__section-subtitle">
              Review your selections before submitting the cloning job.
            </p>
          </div>

          <div class="automation-page__content-slot">
            <app-batch-cloning-summary [singleCount]="summary().singleCount" [myaCount]="summary().myaCount"
              [expiringCount]="summary().expiringCount" [notifyEmail]="notifications().email"
              [notifySms]="notifications().sms" [notifyInApp]="notifications().inApp"
              [notifySuperAdmin]="notifications().superAdmin" [notifyAdmins]="notifications().admins"
              (notifyEmailChange)="updateNotification('email', $event)"
              (notifySmsChange)="updateNotification('sms', $event)"
              (notifyInAppChange)="updateNotification('inApp', $event)"
              (notifySuperAdminChange)="updateNotification('superAdmin', $event)"
              (notifyAdminsChange)="updateNotification('admins', $event)"></app-batch-cloning-summary>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="automation-page__footer">
    <div class="automation-page__footer-left">
      Step {{ currentStep() }} of 4
    </div>

    <div class="automation-page__footer-right">
      <button type="button" class="btn btn-outline-secondary" *ngIf="currentStep() === 1" (click)="location.back()">
        Cancel
      </button>

      <button type="button" class="btn btn-outline-secondary" *ngIf="currentStep() > 1" (click)="goToPreviousStep()">
        ← Back
      </button>

      <button type="button" class="btn btn-primary" *ngIf="currentStep() < 4" (click)="goToNextStep()">
        Next →
      </button>

      <button type="button" class="btn btn-primary" *ngIf="currentStep() === 4" (click)="submitJob()">
        Submit Job
      </button>
    </div>
  </div>
</div>